import { createContext, useContext } from "react";

/**
 * Markdown 本文へ埋め込まれたアップロードファイル（S3 URL）の変換結果。
 *
 * 本文には元ファイルの URL しか書かれていないため、サムネイルや最適化画像は
 * ページ側が別途まとめて取得し、このコンテキストで MarkdownContent へ渡す
 * （例: タスクボードは media-info API で MediaConvertJob を引く）。
 * Provider が無い場所（ノート等）では何も差し替えない。
 */
export interface EmbeddedMediaInfo {
  /** 動画の先頭フレーム / PDF の 1 ページ目 */
  thumbnailUrl?: string | null;
  /** 画像の最適化版（元画像の代わりに表示する） */
  imageUrl?: string | null;
}

// eslint-disable-next-line no-unused-vars
export type EmbeddedMediaResolver = (url: string) => EmbeddedMediaInfo | undefined;

export const EmbeddedMediaContext = createContext<EmbeddedMediaResolver | null>(
  null,
);

/** URL の変換結果（Provider が無い・未変換なら undefined） */
export const useEmbeddedMedia = (
  url: string | undefined,
): EmbeddedMediaInfo | undefined => {
  const resolve = useContext(EmbeddedMediaContext);
  return url && resolve ? resolve(url) : undefined;
};
